// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'bell';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M7.5 16.313a1.565 1.565 0 0 0 3.004 0M9 2.25V.562M9 2.25a5.625 5.625 0 0 1 5.625 5.625c0 5.285 1.125 6.188 1.125 6.188H2.25s1.125-1.438 1.125-6.188A5.625 5.625 0 0 1 9 2.25z'
  />
);

export const viewBox = '0 0 18 18';
